import React, { useContext } from 'react'
import { css, keyframes } from 'emotion'
import { View } from 'oio-react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import ThemeContext from 'src/libraries/contexts/Theme'
import BlogHome from './apps/Home'
import BlogView from './apps/View'

const animateIn = keyframes`
   0% {
      opacity: 0;
      transform: translate3d(0, 5%, 0);
   }

   100% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
   }
`

const Blog = () => {
   const match = useRouteMatch()
   const theme = useContext(ThemeContext)

   return (
      <View
         className={css`
            opacity: 1;
            animation: ${animateIn} 700ms ease both;
         `}
         minHeight="100vh"
         borderLeft={`1px solid ${theme.tmpBorderColor}[d-f]`}
         width="100%">
         <Switch>
            <Route exact path={match.path} component={BlogHome} />
            <Route path={`${match.path}/:initiativeSlug`} component={BlogView} />
         </Switch>
      </View>
   )
}

export default Blog
